import React, { PureComponent } from 'react';
import { CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import TablaNiveles from './components/TablaNiveles';
import { loadEstadisticasNuevos } from '../../redux/actions/reporteActions';
import saga from './saga';
import injectSaga from '../../utils/injectSaga';
import TablaProgramas from './components/TablaProgramas';
import Tarjeta from './components/Tarjeta';
import { CICLO_LECTIVO_A_MATRICULAR_SOLO_ANIO } from '../../utils/constants';

class ReporteEstadisticas extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    app: PropTypes.shape({}).isRequired,
    reporte: PropTypes.shape({}).isRequired,
  };

  componentDidMount() {
    const { dispatch, app } = this.props;
    dispatch(loadEstadisticasNuevos(app.session.id, CICLO_LECTIVO_A_MATRICULAR_SOLO_ANIO));
  }

  render() {
    const {
      t, app, reporte,
    } = this.props;

    return (
      (!app.session || reporte.loading || Object.keys(reporte.statsNuevos).length === 0)
        ? <CircularProgress className="circular-progress" />
        : (
          <Container className="dashboard">
            <Row>
              <Col md={12}>
                <h3 style={{ display: 'inline' }} className="page-title">{t('Estadísticas Generales de Matrícula - Nuevos Ingresos')}</h3>
              </Col>
            </Row>
            <Row>
              <Tarjeta color="green" valor={reporte.statsNuevos.instituto.cantidad.toString()} titulo={t('Total de matrículas')} />
              <Tarjeta color="green" valor={`${reporte.statsNuevos.instituto.cantidadHombres} (${reporte.statsNuevos.instituto.cantidadHombresPorcentaje}%)`} titulo={t('Total de hombres')} />
              <Tarjeta color="green" valor={`${reporte.statsNuevos.instituto.cantidadMujeres} (${reporte.statsNuevos.instituto.cantidadMujeresPorcentaje}%)`} titulo={t('Total de mujeres')} />
              <Tarjeta color="yellow" valor={reporte.statsNuevos.instituto.pendientesContrato.toString()} titulo={t('Matrículas Pendientes de Contrato')} />
              <Tarjeta color="red" valor={reporte.statsNuevos.instituto.pendientes.toString()} titulo={t('Matrículas Pendientes')} />
            </Row>
            <Row>
              <TablaProgramas estadisticas={reporte.statsNuevos} />
            </Row>
            <Row>
              <TablaNiveles estadisticas={reporte.statsNuevos} />
            </Row>
          </Container>
        )
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
  reporte: state.reporte,
});

const withSaga = injectSaga({ key: 'estadisticas', saga });

export default withSaga(connect(mapStateToProps)(withTranslation('common')(ReporteEstadisticas)));
